import { render } from "./FangAnView.vue?vue&type=template&id=e28f8aec&scoped=true&ts=true"
import script from "./FangAnView.vue?vue&type=script&lang=ts"
export * from "./FangAnView.vue?vue&type=script&lang=ts"

import "./FangAnView.vue?vue&type=style&index=0&id=e28f8aec&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\fushuliang2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e28f8aec"]])

export default __exports__